/**
 * The app-wide backend-status poll, in one place.
 *
 * Both the desktop sidebar and the phone top bar show backend status. Each
 * calling the hook would double the request rate, so the shell calls it ONCE
 * and passes the result down.
 */

import { getHealth } from "../lib/api";
import { useApi } from "./useApi";
import type { Tone } from "../components/StatusDot";

export interface AppStatus {
  tone: Tone;
  statusText: string;
  statusTitle: string;
}

export function useAppStatus(): AppStatus {
  const health = useApi(getHealth, [], { pollMs: 60_000 });

  let tone: Tone = "muted";
  let statusText = "перевіряю…";
  let statusTitle = "";
  if (health.error) {
    tone = "danger";
    statusText = "офлайн";
    statusTitle = health.error;
  } else if (health.data) {
    const bad = health.data.sources.filter((s) => s.configured && !s.ok);
    if (!health.data.ok || bad.length > 0) {
      tone = "warn";
      statusText = bad.length > 0 ? `${bad.length} джерел збоять` : "часткові дані";
      statusTitle = bad.map((s) => `${s.name}: ${s.detail ?? "недоступно"}`).join("\n");
    } else {
      tone = "ok";
      statusText = "все працює";
    }
  }

  return { tone, statusText, statusTitle };
}
